import table from './src/Table'

export default table



// WEBPACK FOOTER //
// ./~/iexplore/components/table/index.js